import { FileWarning, Repeat, UserX, Puzzle, Sparkles } from "lucide-react";

const worries = [
    {
        Icon: FileWarning,
        title: "Excelが増えすぎて 管理が大変",
        body: "ファイルが乱立、最新版が分からない。ミスや漏れが怖い。",
    },
    {
        Icon: Repeat,
        title: "同じ内容を 何度も入力している",
        body: "受注、シフト、請求書...同じデータを別々に。時間がもったいない。",
    },
    {
        Icon: UserX,
        title: "担当者しか わからない作業がある",
        body: "属人化していて、引き継ぎや休みのときに業務が止まる。",
    },
    {
        Icon: Puzzle,
        title: "市販システムが 業務に合わない",
        body: "高い割に使わない機能ばかり。逆に必要な機能が足りない。",
    },
];

export default function Worries() {
    return (
        <section
            id="worries"
            data-testid="worries-section"
            className="relative py-24 sm:py-32 bg-white"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <div className="text-center max-w-3xl mx-auto">
                    <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#FFF6E0] border border-[#F5DDB0] text-xs font-bold tracking-widest uppercase text-[#A6791B]">
                        <Sparkles size={14} strokeWidth={2.5} />
                        できること
                    </div>
                    <h2
                        data-testid="worries-title"
                        className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1F2A23] leading-tight"
                    >
                        こんなお悩み、
                        <br />
                        ありませんか？
                    </h2>
                    <p className="mt-5 text-base sm:text-lg text-[#5C6B5E]">
                        中小企業の現場でよくある「困った」。やさまる開発は、ぜんぶまるく解決します。
                    </p>
                </div>

                <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
                    {worries.map((w, idx) => (
                        <div
                            key={w.title}
                            data-testid={`worry-card-${idx}`}
                            className="relative rounded-2xl bg-[#FAFCF5] border border-[#E6EFD8] p-6 sm:p-7 hover:bg-white hover:-translate-y-1 hover:shadow-soft-lg transition-all duration-300"
                        >
                            {/* speech bubble tail */}
                            <span
                                aria-hidden
                                className="absolute -bottom-3 left-8 w-6 h-6 bg-[#FAFCF5] border-r border-b border-[#E6EFD8] rotate-45"
                            />
                            <div className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-white border border-[#C8E0AC] text-[#7DB856] shadow-soft">
                                <w.Icon size={22} strokeWidth={2.5} />
                            </div>
                            <h3 className="mt-4 text-lg sm:text-xl font-extrabold text-[#1F2A23] leading-tight">
                                {w.title}
                            </h3>
                            <p className="mt-3 text-sm text-[#5C6B5E] leading-relaxed">
                                {w.body}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="mt-16 text-center">
                    <p className="text-xl sm:text-2xl font-extrabold text-[#2F5F1A]">
                        ぜんぶ、
                        <span className="text-[#7DB856]">やさまる開発</span>
                        にお任せください。
                    </p>
                </div>
            </div>
        </section>
    );
}
